
        var result = require("!!../../../../../../mini-css-extract-plugin/dist/loader.js!../../../../../../css-loader/index.js??ref--10-3!../../../../../../sass-loader/dist/cjs.js??ref--10-4!./pie-chart-builder.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    